<template>
  <!--<transition name="custom-classes-transition"-->
  <!--enter-active-class="animated slideInRight"-->
  <!--leave-active-class="animated slideOutLeft"-->
  <!--&gt;-->
  <div class="guest GuestType.vue">

    <div class="content">
      <a href="javascript:;" class="go-back" @click="goBack()">
        <arrowBack></arrowBack>
      </a>

      <h1 class="title-primary text-center animated fadeInDown delay1000ms">
        Massa! <br>
        O que te fez chegar até a gente<span v-show="isNameNotEmpty">, </span><span class="sub"> {{ guestName }}?</span>
      </h1>
      <!-- /.title-primary -->
      <div class="choice-list animated fadeInDown delay1000ms">
        <div class="form-check"
             v-bind:class="{'animated fadeCheck': isNotGuestType('client'), 'move-to-right':(guestType === 'client')}">
          <div class="checkbox">
            <label class="form-check-label" v-bind:class="{'white selected': (guestType === 'client')}">
              <input v-model="guestType" class="form-check-input" type="radio" name="guestType" value="client">
              <span></span>
              Gostaria de um orçamento para minha empresa.
            </label>
          </div><!-- /.checkbox -->
        </div>
        <div class="form-check"
             v-bind:class="{'animated fadeCheck': isNotGuestType('candidate'), 'move-to-left':(guestType === 'candidate')}">
          <div class="checkbox">
            <label class="form-check-label" v-bind:class="{'white selected': (guestType === 'candidate')}">
              <input v-model="guestType" class="form-check-input" type="radio" name="guestType" value="candidate">
              <span></span>
              Sou um profissional/estudante
              e quero trabalhar com vocês.
            </label>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- /.clearfix -->
      </div>
      <!-- /.choice-list -->
    </div>
    <!-- /.content -->


  </div>
  <!--</transition>-->
</template>

<script>
  //  import MainMenu from './MainMenu.vue'
  import logo from '../assets/logo.svg'
  import arrowBack from './arrowBack.vue'

  export default {
    name: 'GuestType',
    data() {
      return {}
    },
    computed: {
      guestName() {
        return this.$store.getters.guestFirstName;
      },
      guestType: {
        get() {
          return this.$store.state.guestType;
        },
        set(value) {
          this.$store.commit('setGuestType', value);
        }
      }
    },
    watch: {
      guestType(val) {
        let $this = this;
        if (val === 'candidate') {
          setTimeout(() => {
            $this.$router.push('candidate');
          }, 700);
        } else if (val === 'client') {
          setTimeout(() => {
            $this.$router.push('/client/overview');
          }, 700);
        }
      }
    },
    mounted() {
      this.log('mounted: ' + this.$options.name);

      if (this.guestType !== '') {
        this.$store.commit('setGuestType', '');
      }

      // seta a classe do menu principal
      this.$store.commit('setMenuClass', '');

      if (!this.$store.state.guestName) {
        console.log('making fake guest...');
        this.$store.commit('setGuestName', '');
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      isNotGuestType(val) {
        return this.guestType && (this.guestType !== val);
      },
      isNameNotEmpty() {
        return this.$store.state.guestName !== '';
      }
    },
    components: {
      arrowBack,
      logo
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/GuestType.vue